import {remCalc} from '_themeUtils'

interface StyleProps {
    isTransparentMode: boolean
    isAtTop: boolean
    isInSidebar: boolean
}

const topbar = {
    Topbar: {
        baseStyle: ({isTransparentMode, isAtTop, isInSidebar}: StyleProps) => ({
            topbar: {
                position: 'relative',
                gridTemplateAreas: isAtTop
                    ? {
                          base: `"menu menu" "left right"`,
                          lg: `"left right" "menu menu"`,
                      }
                    : {
                          base: `"menu menu" "left right"`,
                          md: `"left right" "menu menu"`,
                          '2xl': `"left menu right"`,
                      },
                gridTemplateColumns: isAtTop ? '1fr 1fr' : {base: '1fr 1fr', xl: 'auto 1fr auto'},
                gap: isAtTop && {base: remCalc(29), lg: 'spacing.12'},
                columnGap: !isAtTop && {'2xl': 'spacing.3'},
            },
            topbarLeftWrapper: {
                pt: !isInSidebar && 'spacing.4',
                pl: !isInSidebar && {base: 'spacing.4', lg: 'spacing.6'},
            },
            topbarLeft: {
                pb: {base: 'spacing.4', lg: 0},
                spacing: {base: 'spacing.4', '2xl': 'spacing.6'},
                width: 'fit-content',
            },
            topbarRight: {
                pt: !isInSidebar && 'spacing.4',
                pr: !isInSidebar && {base: 'spacing.4', lg: 'spacing.6'},
                direction: 'row',
                spacing: 'spacing.4',
                justify: 'flex-end',
                pb: {base: 'spacing.4', lg: 0},
            },
            topbarRightSidebar: {
                direction: 'column',
                spacing: 0,
            },
            logoContainer: {
                position: 'absolute',
                display: !isAtTop && 'none',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                pt: {base: 'spacing.2', lg: 'spacing.4'},
                pb: {base: 'spacing.4', lg: 0},
            },
            logoImage: {
                w: {base: remCalc(180), lg: remCalc(200)},
                h: {base: remCalc(57), lg: remCalc(64)},
                fit: 'contain',
                filter: {base: 'none', xl: isTransparentMode && `invert(1)`},
            },
        }),
    },
}

export default topbar
